/**
 * Script faces used to render typed signatures.
 *
 * These are system font stacks rather than webfonts: the artifact that carries
 * legal weight is the sealed evidence record, not the glyphs, and loading a font
 * from a third-party CDN is not worth the privacy and CSP cost for decoration.
 */
export const SIGNATURE_FONTS = [
  { id: 'cursive-1', label: 'Flowing', stack: '"Segoe Script", "Bradley Hand", "Brush Script MT", cursive' },
  { id: 'cursive-2', label: 'Classic', stack: '"Snell Roundhand", "Apple Chancery", "URW Chancery L", cursive' },
  { id: 'serif-1', label: 'Formal', stack: 'Georgia, "Times New Roman", serif' },
  { id: 'sans-1', label: 'Plain', stack: '"Helvetica Neue", Arial, sans-serif' },
] as const

/** Resolve a font id to its CSS stack, falling back to the default face. */
export const signatureFontStack = (fontId: string | null | undefined): string =>
  SIGNATURE_FONTS.find((option) => option.id === fontId)?.stack ?? SIGNATURE_FONTS[0].stack
